// extracted by mini-css-extract-plugin
export default {"tabsList":"sG62hEsfDYJcO9pUyO1N"};